/* eslint-disable react/prop-types */
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import { ui } from "ui/tokens";

export const columns = [
  { name: "reconocimiento", align: "left" },
  { name: "tipo", align: "center" },
  { name: "creado", align: "center" },
  { name: "action", align: "center" },
];

const formatDate = (d) => {
  if (!d) return "-";
  try {
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return d;
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yy = String(dt.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  } catch { return d; }
};

export default function buildReconocimientosTableData(items = [], adapter) {
  const rows = (items || []).map((raw, idx) => {
    const r = adapter
      ? adapter(raw, idx)
      : {
          id: raw.id ?? raw._id ?? idx,
          nombre: raw.name ?? raw.nombre ?? "-",
          tipo: raw.type ?? raw.tipo ?? "-",
          creado: raw.created_at ?? raw.createdAt,
          onEdit: () => {},
          onDelete: () => {},
        };

    return {
      reconocimiento: (
        <SoftTypography variant="button" fontWeight="medium">{r.nombre}</SoftTypography>
      ),
      tipo: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {r.tipo}
        </SoftTypography>
      ),
      creado: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {formatDate(r.creado)}
        </SoftTypography>
      ),
      action: (
        <SoftBox display="flex" gap={0.5} justifyContent="center">
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={(e) => { e.preventDefault(); r.onEdit?.(r); }}
              sx={{
                "& .icon-edit": { color: ui.icon?.edit?.base || "#0ea5e9" },
                "&:hover .icon-edit": { color: ui.icon?.edit?.hover || "#0284c7" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-edit" fontSize="small">edit</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton
              size="small"
              onClick={(e) => { e.preventDefault(); r.onDelete?.(r); }}
              sx={{
                "& .icon-del": { color: ui.icon?.del?.base || "#ef4444" },
                "&:hover .icon-del": { color: ui.icon?.del?.hover || "#b91c1c" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-del" fontSize="small">delete</Icon>
            </IconButton>
          </Tooltip>
        </SoftBox>
      ),
    };
  });

  return { columns, rows };
}
